const routes = [
  {
    path: "/styleguide",
    name: "Styleguide",
    component: () =>
      import(/* webpackChunkName: "styleguide" */ "@/views/Styleguide.vue"),
    meta: {
      admin: true,
    },
  },
];

export default routes;
